/**
 * Minimal, dependency-free debug logging for the game engine (src/game/).
 *
 * Deliberately NOT a re-export of ../utils/debugUtils: that module statically
 * imports @capacitor/core to detect native platforms, which breaks module
 * loading outside a browser (e.g. the Node backend, which runs this same
 * engine directly — see RONDA_ONLINE.md Fase 4). Checking
 * globalThis.Capacitor here instead (guarded by `typeof window`) preserves
 * the exact same behavior in the browser/native app — Capacitor's native
 * shell injects that global into the WebView regardless of whether
 * @capacitor/core is imported anywhere — while safely resolving to "not
 * native" under Node, where there is no such global at all.
 */

function isNativePlatform() {
    if (typeof window === 'undefined') return false;
    return Boolean(globalThis.Capacitor?.isNativePlatform?.());
}

function isDebugModeEnabled() {
    return typeof process !== 'undefined' && process.env?.REACT_APP_DEBUG_MODE === 'true';
}

function shouldLog() {
    return isNativePlatform() || isDebugModeEnabled();
}

export const debugLog = (...args) => {
    if (shouldLog()) console.log(...args);
};

export const debugWarn = (...args) => {
    if (shouldLog()) console.warn(...args);
};

export const debugError = (...args) => {
    if (shouldLog()) console.error(...args);
};

export const debugTable = (...args) => {
    if (shouldLog()) console.table(...args);
};

export const debugGroup = (...args) => {
    if (shouldLog()) console.group(...args);
};

export const debugGroupEnd = () => {
    if (shouldLog()) console.groupEnd();
};
